import React from 'react';

const ClockIcon: React.FC = (): React.ReactElement => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="19"
        viewBox="0 0 18 19"
        fill="none">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18 9.5C18 4.52944 13.9706 0.5 9 0.5C4.02944 0.5 0 4.52944 0 9.5C0 14.4706 4.02944 18.5 9 18.5C13.9706 18.5 18 14.4706 18 9.5ZM1.125 9.5C1.125 5.15076 4.65076 1.625 9 1.625C13.3492 1.625 16.875 5.15076 16.875 9.5C16.875 13.8492 13.3492 17.375 9 17.375C4.65076 17.375 1.125 13.8492 1.125 9.5ZM9.5625 9.59651V3.3125H8.4375V10.0625L11.6195 13.2445L12.415 12.449L9.5625 9.59651Z"
          fill="white"
        />
      </svg>
    </>
  );
};

export default ClockIcon;
